// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"830":"a04bcf77","881":"40514e36"}[chunkId] + ".chunk.js";
};